import type { FC } from 'react';

import { AppLogo } from 'features/app-logo/components';
import { AppVersion } from 'features/app-version/components';
import styled from 'features/theme/styled';
import theme from 'features/theme/theme';
import { LeaveQueueButton } from 'features/leave-queue/components';

interface CallReceivedHeaderProps {
  onLeaveQueue: () => void;

  showLeaveQueueButton: boolean;
}

export const CallReceivedHeader: FC<CallReceivedHeaderProps> = ({
  onLeaveQueue,

  showLeaveQueueButton,
}) => {
  return (
    <Container>
      <LogoSection>
        <AppLogo />
        <AppVersion />
      </LogoSection>
      <RightSection>
        {showLeaveQueueButton && (
          <StyledLeaveQueueButton onClick={onLeaveQueue} />
        )}
      </RightSection>
    </Container>
  );
};

const Container = styled('div')`
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${theme.spacing(0, 16)};
  background-color: ${theme.palette.grey[700]};
  height: 96px;
  border-bottom: 8px solid ${theme.palette.deepChampagne[500]};
  width: 100%;
`;

const LogoSection = styled('div')`
  display: flex;
  justify-items: center;
  height: 44px;
`;

const RightSection = styled('div')`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(8)};
`;

const StyledLeaveQueueButton = styled(LeaveQueueButton)`
  min-width: auto;
`;
